import React from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";

export default function ConfirmDialog({ open, title, description, confirmLabel = "Delete", onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div className="admin-modal-layer" role="presentation" onMouseDown={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="admin-confirm" role="alertdialog" aria-modal="true" aria-labelledby="confirm-title">
        <div className="admin-confirm-icon"><ExclamationCircleOutlined /></div>
        <h3 id="confirm-title">{title}</h3><p>{description}</p>
        <div><button className="admin-secondary-button" onClick={onCancel}>Cancel</button><button className="admin-danger-button" onClick={onConfirm}>{confirmLabel}</button></div>
      </div>
    </div>
  );
}
